var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"id":"header","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[(_vm.isProductNameDisplayed)?_c('div',{class:_vm.productNameClass},[_vm._v(" "+_vm._s(_vm.getProductName)+" ")]):_vm._e(),(_vm.isProductPriceDisplayed)?_c('div',{class:_vm.productPriceClass},[_vm._v(" "+_vm._s(_vm.getProductPrice)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }